import { createGenericSlice } from '../../../../../utils/slices'

export const jackSlice = createGenericSlice({
  name: 'jack',
  initialState: {
    type: 'truss',
    material: 5,
    width: 1.5,
    depth: 5.5,
    ply: 1,
    memberID: 'Jack 1',
    load: 0,
    uplift: 0,
    // slopeType: 0,
    skewAngle: 0,
    slopeAngle: 0,
  },
})

export const jackActions = jackSlice.actions
